import React from 'react';
import { CSSTransitionGroup } from 'react-transition-group';
import classNames from 'classnames';
import { transition } from 'lib/helpers';

export const BRUSH_SIZE_MAP = {
	'small': 1,
	'normal': 3,
	'large': 7,
};

export const TEXT_SIZE_MAP = {
	'small': 14,
	'normal': 24,
	'large': 36,
}

export const BRUSH_COLOR_MAP = {
	'red': '#ff411d',
	'yellow': '#ffe729',
	'green': '#76d623',
	'blue': '#2a9bff',
	'gray': '#676767',
	'white': '#ffffff',
}

export function BrushToolbar({ mode, isTextBrush, brushWidth, brushColor, fontSize, onChange, anchorOffset, active }) {
	const sizeType = isTextBrush ? 'text' : 'dot';

	const SizeButton = ({ sizeName, children }) => {
		const size = isTextBrush ? TEXT_SIZE_MAP[sizeName] : BRUSH_SIZE_MAP[sizeName];
		const className = classNames('image-edit-btn', `${sizeType}-${sizeName}`, {
			actived: size == (isTextBrush ? fontSize : brushWidth)
		});
		return (
			<button
				className={className}
				onClick={() => onChange({ [ isTextBrush ? 'fontSize' : 'brushWidth' ]: size, brushColor })}>
				{children}
			</button>
		);
	};

	const ColorButton = ({ colorName, children }) => {
		const color = BRUSH_COLOR_MAP[colorName];
		const className = classNames('image-edit-btn', `color-${colorName}`, {
			actived: color == brushColor
		});
		return (
			<button className={className} style={{ backgroundColor: color }} onClick={() => onChange({ brushWidth, brushColor: color })}>{children}</button>
		);
	}

	return (
		<CSSTransitionGroup
			component="div"
			className="tools-container"
			style={{
				transition: 'transform .6s ease',
				transform: `translate3d(${anchorOffset}px, 0, 0)`,
			}}
			{...transition.slide({ enterPosition: { x: 0, y: -10 }})}
		>
			{ active &&
				<div className="toolbar sub" style={{ position: 'relative', top: 0 }}>
					<SizeButton sizeName="small">小号</SizeButton>
					<SizeButton sizeName="normal">常规</SizeButton>
					<SizeButton sizeName="large">大号</SizeButton>
					{ mode !== 'mosaic' && ([
							<span key="split" className="split"></span>,
							<ColorButton key="red" colorName="red">红色</ColorButton>,
							<ColorButton key="yellow" colorName="yellow">黄色</ColorButton>,
							<ColorButton key="green" colorName="green">绿色</ColorButton>,
							<ColorButton key="blue" colorName="blue">蓝色</ColorButton>,
							<ColorButton key="gray" colorName="gray">灰色</ColorButton>,
							<ColorButton key="white" colorName="white">白色</ColorButton>
						])
					}
				</div>
			}
		</CSSTransitionGroup>
	)
}



// WEBPACK FOOTER //
// ./lib/editor/DraftEditor/plugins/imagePlugin/ImageEditor/BrushToolbar.jsx